export default __webpack_public_path__ + "static/media/2189.68cb8545.png";